// extracted by mini-css-extract-plugin
export default {"productCarousel":"jZ-z"};